var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcedureAssistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5C2.89543 5 2 5.89543 2 7V15C2 16.1046 2.89543 17 4 17H7V20.2192C7 20.9678 7.85742 21.3931 8.45605 20.9426L13 17.5H20C21.1046 17.5 22 16.6046 22 15.5V7C22 5.89543 21.1046 5 20 5H4ZM3.5 7C3.5 6.72386 3.72386 6.5 4 6.5H20C20.2761 6.5 20.5 6.72386 20.5 7V15.5C20.5 15.7761 20.2761 16 20 16H12.75C12.5842 16 12.4224 16.0507 12.2865 16.1451L8.5 18.7931V16.75C8.5 16.3358 8.16421 16 7.75 16H4C3.72386 16 3.5 15.7761 3.5 15.5V7Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 11,
    r: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 11,
    r: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedureAssistant);
export default __webpack_public_path__ + "static/media/procedure-assistant.c0188af8eb772a6133c610aec616d128.svg";
export { ForwardRef as ReactComponent };